import { render, staticRenderFns } from "./BrandEditDetails.vue?vue&type=template&id=152e3de8&"
import script from "./BrandEditDetails.vue?vue&type=script&lang=js&"
export * from "./BrandEditDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports